import React from "react"
import "./styles.scss"
import Img from "gatsby-image"
const SectionImage = ({ image, mobileImage, alt }) => {
  const sources = [
    {
      ...mobileImage,
      media: `(max-width: 767px)`,
    },
    {
      ...image,
      media: `(min-width: 768px)`,
    },
  ]
  return <Img fluid={sources} />
}

export default SectionImage
